import SyosUiContainer from './SyosUiContainer';
import SyosPageComponent from './components/SyosPageComponent';
import SvgIcon from '../utils/SvgIcon';
import IconSprites from '../utils/IconSprites';

/** @typedef {import("./SyosController").default} SyosController */
/** @typedef {import("./utils/SyosFullscreenManager").default} SyosFullscreenManager */

function getHtml() {
  const { labelEnterFullScreen, labelExitFullScreen } = SyosPageComponent;

  return `
    <button class="btn btn-default tn-syos-btn-toggle-full-screen" type="button">
      <span class="tn-syos-btn-toggle-full-screen__label-enter" aria-label="${labelEnterFullScreen}">
        ${SvgIcon.getHtml(IconSprites.ArrowsAngleExpand, 'tn-syos-btn-toggle-full-screen__icon')}
      </span>
      <span class="tn-syos-btn-toggle-full-screen__label-exit" aria-label="${labelExitFullScreen}">
        ${SvgIcon.getHtml(IconSprites.ArrowsAngleContract, 'tn-syos-btn-toggle-full-screen__icon')}
      </span>
    </button>
  `;
}

class SyosBtnToggleFullScreen extends SyosUiContainer {
  /**
   * @param {SyosController} syosController
   * @param {SyosFullscreenManager} fullscreenManager
   */
  constructor(syosController, fullscreenManager) {
    super(syosController, '.tn-syos-btn-toggle-full-screen__container');

    this.$el.html(getHtml());

    const $btn = this.find('.tn-syos-btn-toggle-full-screen');

    $btn.on('click', () => {
      fullscreenManager.toggleFullscreen();
    });
  }
}

export default SyosBtnToggleFullScreen;
